import { Box, Link, Stack, Typography } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const policies = [
  {
    label: 'Digital Privacy Policy',
    href: 'https://www.nica.com/digital-privacy-policy/',
  },
  {
    label: 'Terms and Conditions',
    href: 'https://www.nica.com/website-and-hosted-payment-page-terms-and-conditions/', // PLACEHOLDER
  },
  {
    label: 'Authorize.net Privacy Information',
    href: 'https://www.authorize.net/about-us/privacy.html',
  },
];

export function PaymentConfirmationDisclosure() {
  return (
    <Box
      component="section"
      aria-label="Payment disclosure and policies"
      sx={{
        p: 2,
        mt: 2,
        bgcolor: 'background.default',
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
      }}
    >
      <Typography component="p" variant="caption" color="text.secondary" sx={{ m: 0 }}>
        When you select "Confirm", NICA sends the selected provider identifiers, including license
        numbers, payment amounts, and related transaction information to Authorize.net.
        Authorize.net operates the payment form displayed within this page and collects your payment
        credentials and billing information. NICA receives transaction information to apply and
        reconcile your payment. Links to the Provider Privacy Policies below.
      </Typography>

      <Stack spacing={0.5} sx={{ mt: 1 }}>
        {policies.map(({ label, href }) => (
          <Link
            key={label}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            variant="caption"
            aria-label={`${label} (opens in a new tab)`}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.5,
              alignSelf: 'flex-start',
            }}
          >
            {label}
            <OpenInNewIcon aria-hidden="true" sx={{ fontSize: '1em' }} />
          </Link>
        ))}
      </Stack>
    </Box>
  );
}
